module.exports = __webpack_public_path__ + "static/media/404.24f1671b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/containers/misc/404.gif
// module id = 867
// module chunks = 0